/*
 *  Copyright IBM Corp. 2025
 *
 *  This source code is licensed under the Apache-2.0 license found in the
 *  LICENSE file in the root directory of this source tree.
 *
 *  @license
 */

import React from "react";

import { useLanguagePack } from "../../../hooks/useLanguagePack";
import { ErrorIcon } from "../../ErrorIcon";
import { MarkdownWithDefaults } from "../../../components/util/MarkdownWithDefaults";

export function InlineError({ text }: { text?: string }) {
  const languagePack = useLanguagePack();
  return (
    <div className="cds-custom-aichat--inline-error">
      <div className="cds-custom-aichat--inline-error--icon-holder">
        <ErrorIcon className="cds-custom-aichat--inline-error--icon" />
      </div>
      <div className="cds-custom-aichat--inline-error--text">
        <MarkdownWithDefaults
          removeHTML
          text={text || languagePack.errors_generalContent}
          highlight={true}
        />
      </div>
    </div>
  );
}

export default InlineError;
